var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "proxy", staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-12 col-lg-12" },
      [
        _c(
          "c-card",
          {
            staticClass: "cardClassDetailInfo",
            attrs: { title: "범례", topClass: "topcolor-orange" },
          },
          [
            _c(
              "template",
              { slot: "card-button" },
              [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [
                    _c("c-btn", {
                      attrs: {
                        label: "적용",
                        editable: _vm.editable,
                        icon: "save",
                      },
                      on: { btnClicked: _vm.saveData },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("template", { slot: "card-detail" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c("c-select", {
                        attrs: {
                          editable: _vm.editable,
                          isArray: false,
                          comboItems: _vm.checkboxItems,
                          itemText: "codeName",
                          itemValue: "code",
                          label: "",
                          name: "checkItems",
                        },
                        model: {
                          value: _vm.checkItems,
                          callback: function ($$v) {
                            _vm.checkItems = $$v
                          },
                          expression: "checkItems",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }